import React from 'react';
import { defineBlock, smartProps, EditableImg, useEditor, ChildrenBlock } from '@smartfire/wordpress-react';
import { InnerBlocks } from '@wordpress/block-editor';
import style from "./block.module.scss";

const template = [
    [ 'core/heading', {
        placeholder: 'Titre',
        lavel: 2
    } ]
];

function Block() {
    const {isEditing} = useEditor();

    return <div className={style.block}>
            <EditableImg className={style.image} smartProp={'image'} />
            <div>
                {isEditing ?
                    <InnerBlocks 
                        template={template}
                        templateLock={'all'}
                    />
                    :
                    <ChildrenBlock />
                }
                <div className={style.underlining} />
            </div>
    </div>;
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.any.withDefault(''),
    },
    setup: {
        title: 'Titre avec picto'
    }
})